import {
    GET_FABRIC_STOCK_REQUEST,
    GET_FABRIC_STOCK_SUCCESS,
    GET_FABRIC_STOCK_ERROR,
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getFabricStock = (token) => (dispatch) => {
    dispatch({ type: GET_FABRIC_STOCK_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/fabricStock`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: GET_FABRIC_STOCK_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_FABRIC_STOCK_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_FABRIC_STOCK_ERROR,
                payload: error.response,
            });
        });
};